export const getCourseDataForEditor = /* GraphQL */ `
id
sk
author
alignmentScopes
bankId
createdAt
creatorId
description
duration
idVendor
grade
language
maturity
copyrightYear
isbn
name
notes
numberLabel
coverImage {
  region
  bucket
  key
}
resources {
  id
  sk
  data
  resource {
    id
    sk
    schemaVersion
    workspaceId
    type
    name
    maturity
    idInc
    file {
      region
      bucket
      key
    }
    workspace {
      id
      name
    }
  }
  tags {
    key
    value
  }
}
subject
units {
  id
  sk
  tags {
    key
    type
    value
  }
  unit {
    id
    sk
    name
    numberLabel
    createdAt
    updatedAt
    maturity
  }
}
unitIds {
  id
  sk
  tags {
    key
    type
    value
  }
}
sequence
tags {
  key
  type
  value
}
updatedAt
workspaceId
`;
